import { Sky } from '@react-three/drei'

const AmbientLight = () => (
    <>
        <Sky scale={20000} sunPosition={[500, 350, -1000]} turbidity={0} />
        <color attach="background" args={['#f0f0f0']} />
        {/* <Stars /> */}
        {/* <pointLight position={[20, 30, 10]} />
        <spotLight intensity={0.5} angle={0.2} penumbra={1} position={[5, 15, 10]} /> */}
    </>
)

export default AmbientLight